import {
  countTotalCostWithoutTaxes,
  countTotalCostWithTaxes,
  countTotalTaxes,
  countTotalCostWithDiscount,
} from '../../../../common/helpers/appointments';

export default function getPaymentDetailsData({ selectedServices, tip = 0, discount, promoAmount, refundedAmount, isRefunded }) {
  const moreThanOneService = selectedServices && selectedServices.length > 1;
  const serviceList = selectedServices.map((service) => {
    const id = service.serviceId || service.id;
    const total = (() => {
      if (selectedServices.length > 1) {
        return service.costWithTaxes;
      }
      return (service.costWithTaxes + tip);
    })();

    return {
      key: id,
      name: service.name,
      cost: service.costWithoutTaxes,
      tax: service.taxAmount,
      serviceId: id,
      total,
    };
  });

  const totalTaxes = countTotalTaxes(selectedServices) || 0;
  const totalPrice = countTotalCostWithoutTaxes(selectedServices);
  const discountedSum = countTotalCostWithDiscount(selectedServices, discount, promoAmount);
  const discounts = totalPrice - discountedSum;

  return {
    serviceList,
    moreThanOneService,
    tip,
    totalTaxes,
    totalPrice,
    total: countTotalCostWithTaxes(selectedServices) + tip,
    discountedTotal: discountedSum && discountedSum + totalTaxes + tip,
    refundedAmount,
    discounts,
    isRefunded,
  };
}
